// Registry of per-slide-type preview components. The dispatcher
// (SlidePreview.vue) looks up a slide id here; if no entry is found, it
// falls back to a generic preview by sectionKey.
//
// Manifests in manifestRegistry.ts take precedence over this Vue
// registry — they're the third-party authoring path. This file is the
// first-party path for slides we own end-to-end.
//
// To add a new preview see ./README.md.

import type { Component } from 'vue'

// Quiz
import PickAnswer from './PickAnswer.vue'
import ShortAnswer from './ShortAnswer.vue'
import SpinnerWheel from './SpinnerWheel.vue'
import MatchPairs from './MatchPairs.vue'
import CorrectOrder from './CorrectOrder.vue'
import Categorise from './Categorise.vue'
import DuckRace from './DuckRace.vue'
import Leaderboard from './Leaderboard.vue'
import TrueFalse from './TrueFalse.vue'
import HotSeat from './HotSeat.vue'
import BuzzerRound from './BuzzerRound.vue'
import Crossword from './Crossword.vue'
import FillBlanks from './FillBlanks.vue'
import MemoryMatch from './MemoryMatch.vue'
import Trivia from './Trivia.vue'
import OddOneOut from './OddOneOut.vue'
import Pictionary from './Pictionary.vue'

// Polls / Unscored
import Poll from './Poll.vue'
import OpenEnded from './OpenEnded.vue'
import WordCloud from './WordCloud.vue'
import Brainstorm from './Brainstorm.vue'
import IdeaBoard from './IdeaBoard.vue'
import PinOnImage from './PinOnImage.vue'
import Ranking from './Ranking.vue'
import RatingScale from './RatingScale.vue'
import Qna from './Qna.vue'
import StickyNotes from './StickyNotes.vue'
import MindMap from './MindMap.vue'
import Fishbowl from './Fishbowl.vue'
import TownHall from './TownHall.vue'
import ImagePair from './ImagePair.vue'
import AudioClip from './AudioClip.vue'
import VideoHost from './VideoHost.vue'

// Engagement / icebreaker / sentiment
import RandomAssignments from './RandomAssignments.vue'
import ADeckOfCards from './ADeckOfCards.vue'
import SneakAPeek from './SneakAPeek.vue'
import WalkingQuestion from './WalkingQuestion.vue'
import Confessions from './Confessions.vue'
import TwoTruthsLie from './TwoTruthsLie.vue'
import MoodMeter from './MoodMeter.vue'
import SentimentCheck from './SentimentCheck.vue'
import PriorityVote from './PriorityVote.vue'
import HeatmapVote from './HeatmapVote.vue'
import Swot from './Swot.vue'
import ProsCons from './ProsCons.vue'

// Content
import ContentSlide from './ContentSlide.vue'
import Heading from './Heading.vue'
import List from './List.vue'
import Image from './Image.vue'
import QrCode from './QrCode.vue'
import Youtube from './Youtube.vue'
import Embed from './Embed.vue'
import Document from './Document.vue'
import Quote from './Quote.vue'
import CodeBlock from './CodeBlock.vue'
import Table from './Table.vue'
import Diagram from './Diagram.vue'
import Timeline from './Timeline.vue'
import CountdownTimer from './CountdownTimer.vue'
import Whiteboard from './Whiteboard.vue'
import CtaBanner from './CtaBanner.vue'

export const PREVIEWS: Record<string, Component> = {
  // Quiz
  'pick-answer': PickAnswer,
  'short-answer': ShortAnswer,
  'spinner-wheel': SpinnerWheel,
  'match-pairs': MatchPairs,
  'correct-order': CorrectOrder,
  categorise: Categorise,
  'duck-race': DuckRace,
  leaderboard: Leaderboard,
  'true-false': TrueFalse,
  'hot-seat': HotSeat,
  'buzzer-round': BuzzerRound,
  crossword: Crossword,
  'fill-blanks': FillBlanks,
  'memory-match': MemoryMatch,
  trivia: Trivia,
  'odd-one-out': OddOneOut,
  pictionary: Pictionary,

  // Polls / Unscored
  poll: Poll,
  'open-ended': OpenEnded,
  'word-cloud': WordCloud,
  brainstorm: Brainstorm,
  'idea-board': IdeaBoard,
  'pin-on-image': PinOnImage,
  ranking: Ranking,
  'rating-scale': RatingScale,
  qna: Qna,
  'sticky-notes': StickyNotes,
  'mind-map': MindMap,
  fishbowl: Fishbowl,
  'town-hall': TownHall,
  'image-pair': ImagePair,
  'audio-clip': AudioClip,
  'video-host': VideoHost,

  // Engagement / icebreaker / sentiment
  'random-assignments': RandomAssignments,
  'a-deck-of-cards': ADeckOfCards,
  'sneak-a-peek': SneakAPeek,
  'walking-question': WalkingQuestion,
  confessions: Confessions,
  'two-truths-lie': TwoTruthsLie,
  'mood-meter': MoodMeter,
  'sentiment-check': SentimentCheck,
  'priority-vote': PriorityVote,
  'heatmap-vote': HeatmapVote,
  swot: Swot,
  'pros-cons': ProsCons,

  // Content
  'content-slide': ContentSlide,
  heading: Heading,
  list: List,
  image: Image,
  'qr-code': QrCode,
  youtube: Youtube,
  embed: Embed,
  document: Document,
  quote: Quote,
  'code-block': CodeBlock,
  table: Table,
  diagram: Diagram,
  timeline: Timeline,
  'countdown-timer': CountdownTimer,
  whiteboard: Whiteboard,
  'cta-banner': CtaBanner,
}
